import { useState, useEffect } from 'react'

export const useIsUSD = () => {
  const [isUSD, useIsUSD] = useState(false)

  useEffect(() => {
    const canadaFlag = localStorage.getItem('isUSD')
    useIsUSD(canadaFlag === 'false')
  }, [])

  return isUSD
}
